export default __webpack_public_path__ + "static/media/sass.903cef0c.svg";